import { render, staticRenderFns } from "./data-view-footer.vue?vue&type=template&id=10594a6c&scoped=true"
import script from "./data-view-footer.vue?vue&type=script&lang=js"
export * from "./data-view-footer.vue?vue&type=script&lang=js"
import style0 from "./data-view-footer.vue?vue&type=style&index=0&id=10594a6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10594a6c",
  null
  
)

export default component.exports